<template>
    <v-card>
        <v-card-title class="font-weight-bold" width="100%">
            Detail Soal

            <!-- <v-chip
        v-if="!details.is_new"
        class="green--text ml-1"
        color="lightgreen"
        small
      >
        New
      </v-chip> -->

            <v-spacer></v-spacer>
            <v-btn icon small @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pa-2" width="100%">
            <v-card flat class="py-5 pa-5">
                <v-row>
                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Kode
                    </v-col>
                    <v-col md="7" class="font-weight-500 font-size-14 py-2">
                        {{ details.kode || "-" }}
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Mata Pelajaran
                    </v-col>
                    <v-col md="7" class="py-2 font-weight-500 font-size-14">
                        {{ details.mapel.nama || "-" }}
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Bab
                    </v-col>
                    <v-col md="7" class="py-2 font-weight-500 font-size-14">
                        {{ details.bab.nama || "-" }}
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Sub Bab
                    </v-col>
                    <v-col md="7" class="py-2 font-weight-500 font-size-14">
                        {{ details.sub_bab ? details.sub_bab.nama : "-" }}
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Sub Sub Bab
                    </v-col>
                    <v-col md="7" class="py-2 font-weight-500 font-size-14">
                        {{
                            details.sub_sub_bab ? details.sub_sub_bab.nama : "-"
                        }}
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Jenjang
                    </v-col>
                    <v-col md="7" class="py-2 font-weight-500 font-size-14">
                        {{ details.jenjang ? details.jenjang.nama : "-" }}
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Kelas
                    </v-col>
                    <v-col md="7" class="py-2">
                        <div>
                            <v-chip
                                v-for="(grade, i) in details.grades
                                    .slice()
                                    .sort((a, b) => a.grade - b.grade)"
                                :key="i"
                                :input-value="true"
                                color="lightblue"
                                class="mr-2 mb-2 blew--text font-weight-600"
                            >
                                {{ grade.display_name || "-" }}
                            </v-chip>
                        </div>
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Tipe Pilihan
                    </v-col>
                    <v-col md="7" class="py-2 font-weight-500 font-size-14">
                        {{ details.tipe_pilihan || "-" }}
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Tingkat Kesulitan
                    </v-col>
                    <v-col md="7" class="py-2 font-weight-500 font-size-14">
                        {{ details.difficulty_level || "-" }}
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Eigen
                    </v-col>
                    <v-col md="7" class="py-2 font-weight-500 font-size-14">
                        {{ details.nilai_eigen || "-" }}
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Label
                    </v-col>
                    <v-col md="7" class="py-2 font-weight-500 font-size-14">
                        {{ details.label || "-" }}
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Status Dimunculkan
                    </v-col>
                    <v-col md="7" class="py-2 font-weight-500 font-size-14">
                        {{ details.is_restricted }}
                    </v-col>
                </v-row>

                <v-divider class="my-7" />

                <v-row>
                    <v-col md="4" class="grey--text font-size-14 py-2">
                        Dibuat Tanggal
                    </v-col>
                    <v-col md="7" class="py-2 font-weight-500 font-size-14">
                        {{ created_date }}
                    </v-col>

                    <v-col md="4" class="grey--text font-size-14 pt-3 pb-1">
                        Status
                    </v-col>

                    <v-col>
                        <v-chip
                            v-if="!details.is_valid"
                            color="#FFEBEE"
                            dark
                            class="pl-1 pr-3 font-size-12 red--text font-weight-500"
                        >
                            <v-icon class="mr-1">mdi-close-circle</v-icon>
                            Belum Tervalidasi
                        </v-chip>

                        <v-chip
                            v-else
                            color="lightgreen"
                            dark
                            class="pl-1 pr-3 font-size-12 green--text font-weight-500"
                        >
                            <v-icon class="mr-1">mdi-check-circle</v-icon>
                            Sudah Divalidasi
                        </v-chip>
                    </v-col>
                </v-row>

                <template v-if="details.is_valid">
                    <v-row>
                        <v-col md="4" class="grey--text font-size-14 py-2">
                            Di Validasi Oleh
                        </v-col>
                        <v-col md="8" class="py-2 font-weight-500 font-size-14">
                            {{ details.pic_vailidate || "-" }}
                        </v-col>

                        <v-col md="4" class="grey--text font-size-14 py-2">
                            Di Validasi Tanggal
                        </v-col>
                        <v-col md="8" class="py-2 font-weight-500 font-size-14">
                            {{
                                $moment(details.updated_at).format(
                                    "DD MMM YYYY"
                                ) || "-"
                            }}
                        </v-col>
                    </v-row>
                </template>
            </v-card>
        </v-card-text>

        <v-card-actions class="py-4">
            <v-spacer></v-spacer>
            <v-btn depressed class="mr-2" @click="$emit('close')">
                Kembali
            </v-btn>

            <v-btn color="blew" depressed dark @click="$emit('preview')">
                Preview
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import Moment from "moment";
export default {
    name: "wacana",
    props: ["details", "loading"],
    data: function () {
        return {
            loading: false,
        };
    },
    computed: {
        created_date() {
            return Moment(this.details.created_at).format("DD MMM YYYY");
        },
    },
    methods: {},
};
</script>



// WEBPACK FOOTER //
// Detail.vue?19397b46